import { Image } from "expo-image";
import { Href, Link } from "expo-router";
import { Pressable, View } from "react-native";
import { useTailwind } from "tailwind-rn";

type Props<T> = {
  routes: RouteProps<T>[];
};

export default function Router<T>({ routes }: Props<T>) {
  const tailwind = useTailwind();

  return (
    <View style={tailwind("gap-4 m-4")}>
      {routes.map((route, i) => (
        <Route key={i} {...route} />
      ))}
    </View>
  );
}

type RouteProps<T> = {
  text: string;
  componentUrl: Href<T>;
  notionUrl?: Href<T>;
};

function Route<T>({ text, componentUrl, notionUrl }: RouteProps<T>) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row gap-4 items-center")}>
      <Link href={componentUrl}>{text}</Link>
      {notionUrl && <NotionLink url={notionUrl} />}
    </View>
  );
}

function NotionLink<T>({ url }: { url: Href<T> }) {
  const tailwind = useTailwind();
  return (
    <Link href={url} asChild>
      <Pressable>
        <Image
          source={require("@/assets/images/notion.png")}
          style={tailwind("h-6 w-6")}
        />
      </Pressable>
    </Link>
  );
}
